module.exports = __webpack_public_path__ + "img/tintim.07d8f88e.svg";